import type { AttributeErrorTO, MrmStateTO } from '@control-center/control-center-client-public-domain-simulation-ts';
import NoData from 'components/content/NoData';

type MrmBadgeConfig = { icon: string; label: string } | { icon?: undefined; label: string };

const MRM_BADGE: Partial<Record<string, MrmBadgeConfig>> = {
    STANDBY: { label: 'STANDBY' },
    PERFORMING: { icon: 'rioglyph-spinner', label: 'PERFORMING' },
    MRC_REACHED: { icon: 'rioglyph-pause', label: 'MRC_REACHED' },
    RELEASING: { icon: 'rioglyph-spinner', label: 'RELEASING' },
    FAULTED: { label: 'FAULTED' },
};

export const AttributeErrorBadge = ({ error }: { error: AttributeErrorTO }) => (
    <span
        className={`SimulationVehicleAttributes__errorBadge SimulationVehicleAttributes__errorBadge--${error.type.toLowerCase()}`}
    >
        <span className='rioglyph rioglyph-exclamation-sign' />
        {error.type}
    </span>
);

interface MrmStateDisplayProps {
    mrmField: { value?: MrmStateTO; error?: AttributeErrorTO } | undefined;
}

const MrmStateDisplay = ({ mrmField }: MrmStateDisplayProps) => {
    if (mrmField?.error) return <AttributeErrorBadge error={mrmField.error} />;
    const mrm = mrmField?.value;
    if (!mrm?.state) return <NoData className='text-14' />;
    const config = MRM_BADGE[mrm.state];
    if (!config) return <>{mrm.state}</>;
    return (
        <span
            className={`SimulationVehicleAttributes__mrmBadge SimulationVehicleAttributes__mrmBadge--${mrm.state.toLowerCase()}`}
        >
            {config.icon && <span className={`rioglyph ${config.icon}`} />}
            {config.label}
            {mrm.executionPhase && <span className='SimulationVehicleAttributes__mrmPhase'>{mrm.executionPhase}</span>}
        </span>
    );
};

export default MrmStateDisplay;
